import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ie-custom-4",
  "use": "icon-ie-custom-4-usage",
  "viewBox": "0 0 1181 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1181 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ie-custom-4\">\r\n    <path d=\"M493.30769268 136.98557724c37.15745224-62.46995225 130.03485589-62.46995225 167.19230732 0l390.10456768 656.27524045C1087.76201911 855.76322134 1041.32331769 933.875 967.00841321 933.875H186.83173089c-74.31490366 0-120.72115366-78.11177866-83.59615364-140.61418231L493.30769268 136.98557724z\" fill=\"#FF7875\" p-id=\"2522\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol